export default __webpack_public_path__ + "static/media/330_business04-nl-mobile.82b9ae8b.png";